import { computed } from 'mobx'
import { schema } from 'prose-core'
import { useContext } from 'react'

import { useEditorView } from 'common/Prose/EditorProvider/hooks/useEditorView'
import {
  FORMAT_OPTIONS,
  NumberedListFormat,
} from 'common/Prose/Toolbar/components/Format/components/ToggleListPane/NumberedListButton/util'
import { turnIntoList } from 'common/Prose/utils/turnIntoList'
import { AlmanacEditorStateContext } from 'stores/EditorState'

import { ButtonHook } from '../Types'

export function useNumberedListMarkerToggle(formatKey: NumberedListFormat): ButtonHook {
  const editorView = useEditorView()
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  const almanacState = useContext(AlmanacEditorStateContext)!

  const active = computed(() => almanacState.activeOlMarkerFormats.has(formatKey)).get()
  const handleClick = turnIntoList(editorView, schema.nodes.ordered_list, FORMAT_OPTIONS[formatKey].attrs)

  return { active, handleClick }
}
